import { IconLoader2 } from '@tabler/icons-react';
import { WarningMessage } from '@common/components';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import useTranslation from '@/hooks/useTranslation';

interface DeleteQuestionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  hasMedia?: boolean;
  isDeletingQuestion?: boolean;
}

function DeleteQuestionModal({
  isOpen,
  onClose,
  onConfirm,
  hasMedia = false,
  isDeletingQuestion = false,
}: DeleteQuestionModalProps) {
  const { lang } = useTranslation();

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{lang.get('msg.deleteQuestion')}</AlertDialogTitle>
          <p className="text-sm dark:text-neutral-400 text-dark-text pb-2">
            {lang.get('msg.areYouSureYouWantToDeleteQuestion')}
          </p>
        </AlertDialogHeader>

        {hasMedia && (
          <WarningMessage>{lang.get('msg.deletingQuestionMediaWarning')}</WarningMessage>
        )}

        <AlertDialogFooter className="mt-4">
          <AlertDialogCancel onClick={onClose}>{lang.get('msg.cancel')}</AlertDialogCancel>
          <Button onClick={onConfirm} className="bg-red-600 hover:bg-red-700">
            {isDeletingQuestion && <IconLoader2 className="animate-spin mr-2" />}
            {isDeletingQuestion ? lang.get('msg.deleting') : lang.get('msg.delete')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default DeleteQuestionModal;
